import React from "react";
import { Row, Col } from "antd";
import AnalyticsContainer from "../../containers/analytics-container";

import "./index.scss";

export default () => (
  <div>
    <Row className="analytics-container">
      <Col span={24}>
        <AnalyticsContainer />
      </Col>
    </Row>
  </div>
);
